interface BarRow {
  label: string;
  value: number;
  displayValue: string;
}

/** Mini grafico de barras horizontales con CSS puro (sin dependencias externas). */
export function KpiBarList({ rows }: { rows: BarRow[] }) {
  const max = Math.max(1, ...rows.map((r) => r.value));
  if (rows.length === 0) return <p className="py-4 text-center text-sm text-ink-400">Sin datos para los filtros seleccionados.</p>;
  return (
    <div className="space-y-2.5">
      {rows.map((row, i) => (
        <div key={i}>
          <div className="mb-1 flex items-center justify-between text-xs">
            <span className="truncate font-medium text-ink-700">{row.label}</span>
            <span className="ml-2 shrink-0 font-semibold text-ink-500">{row.displayValue}</span>
          </div>
          <div className="h-2.5 w-full overflow-hidden rounded-full bg-ink-100">
            <div className="h-full rounded-full bg-brand-500" style={{ width: `${Math.max(4, (row.value / max) * 100)}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
